import { Route, Routes } from "react-router";
import { lazy } from "react";
import NavBar from "./layouts/NavBar";
import HomePage from "./pages/HomePage";
import With from "./layouts/With";
import WithSubscribe from "./layouts/WithSubscribe";
import UnauthorizedPage, { ConflictPage } from "./pages/UnauthorizedPage";
import PolicyPage from "./pages/AdminPage/policy-page";
import CancelMailingList from "./pages/cancel-mailing/cancel-mailing-list";
import Me from "./views/me";
import NotFoundPage from "./pages/NotFoundPage";
import PublicPageLayout from "./layouts/PublicPageLayout";
const SupportPage = lazy(() => import("./pages/SupportPage"));
const PaymentVerify = lazy(() => import("./pages/payment-verify"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const Auth = lazy(() => import("./utils/Auth"));
const Oauth = lazy(() => import("./utils/Oauth"));
const OAuthProfileCompletionPage = lazy(() => import("./pages/OAuthProfileCompletionPage"));
const Logout = lazy(() => import("./utils/Logout"));
const SignUpPage = lazy(() => import("./pages/SignUpPage"));
const SubscriptionPage = lazy(() => import("./pages/SubscriptionPage"));
const SuperAdminLandingPage = lazy(() => import("./layouts/SuperAdminLandingPage"));
const AdminLandingPage = lazy(() => import("./layouts/adminLandingPage"));
const UserLandingPage = lazy(() => import("./layouts/userLandingPage"));
const OTPPage = lazy(() => import("./pages/PreResetPasswordPage"));
const ResetPasswordPage = lazy(() => import("./pages/ResetPasswordPage"));
const AddEmailStage = lazy(() => import("./dev/components/AddEmailStage"));
const RateLimitedPage = lazy(() => import("./pages/RateLimitedPage"));

function App() {
  return (
		<>
		<Routes>
      {/* public routes */}
      {/* <Route path="profile" element={<ProfilePage/>} /> */}
     
      <Route path="/oauth" element={<Oauth />} />
      <Route path="/oauth/complete-profile" element={<OAuthProfileCompletionPage />} />
      <Route path="/logout" element={<Logout />} />
      <Route element={<PublicPageLayout />}>
      <Route path="/zoooz-policy" element={<PolicyPage/>} />
      <Route path="/cancel-mailing-list/:id" element={<CancelMailingList />} />
      <Route path="/payment-verify" element={<PaymentVerify />} />
      <Route path="forgot_password" element={<AddEmailStage />} />
      <Route path="/rate-limited" element={<RateLimitedPage />} />
      <Route path="/password">
        <Route path="verify/:email" element={<OTPPage />} />
        <Route path="reset/:email" element={<ResetPasswordPage />} />
        
      </Route>
      </Route>
      <Route path="/" element={<HomePage />} />

      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="/conflict" element={<ConflictPage />} />
      <Route
        path="/"
        element={
          <With>
            <NavBar />
          </With>
        }>
        <Route element={<PublicPageLayout />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="signup" element={<SignUpPage />} />
        <Route path="subscription" element={<SubscriptionPage />} />
        <Route path="support" element={<SupportPage />} />
        </Route>
      </Route>

      <Route path="/home" element={<HomePage />} />

      {/* protected routes */}
      <Route path="/" element={<Auth />}>
        <Route
          path="*"
          element={
            <With>
              <NavBar></NavBar>
            </With>
          }>
          <Route path="admin/*" element={<AdminLandingPage />} />
          <Route path="superadmin/*" element={<SuperAdminLandingPage />} />
          <Route path="user" element={<WithSubscribe />}>
            <Route path="*" element={<UserLandingPage />} />
            <Route path="me" element={<Me />} />

          </Route>
        </Route>
      </Route>
      {/* catch all */}

      <Route path="*" element={<NotFoundPage />} />
		</Routes>
		</>
  );
}

export default App;
